/**
 * Navigate to a path and scroll to top.
 * For cross-page navigation: navigate() triggers a pathname change,
 * which the global ScrollToTop component handles via useLayoutEffect.
 * For same-page clicks: we scroll manually since pathname doesn't change.
 */
export function navigateAndScroll(navigate, path, currentPath) {
  if (currentPath === path) {
    window.scrollTo(0, 0);
  } else {
    navigate(path);
    // ScrollToTop's useLayoutEffect handles the scroll after DOM update
  }
}

export function scrollToTop() {
  window.scrollTo(0, 0);
}
